var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLpAsset2 = function SvgLpAsset2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "1.038 1.038 52.586 52.586",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    height: 55,
    width: 55,
    "data-type": "ugc",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.925,
    stroke: "url(#lp-asset-2_svg__a)",
    fill: "url(#lp-asset-2_svg__b)",
    d: "M27.331 53.624c14.521 0 26.293-11.772 26.293-26.293 0-14.521-11.772-26.293-26.293-26.293C12.81 1.038 1.038 12.81 1.038 27.33c0 14.521 11.771 26.293 26.293 26.293Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.415,
    stroke: "#171717",
    d: "M27.328 15.628v23.398M39.025 27.33H15.633",
    fill: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 60.02,
    x2: 17.71,
    y1: 0.486,
    x1: 51.95,
    id: "lp-asset-2_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D8E8",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF0E9",
    offset: 0.958
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 48.635,
    x2: 29.349,
    y1: 27.504,
    x1: 35.748,
    id: "lp-asset-2_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.77,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.61,
    stopColor: "#fff",
    offset: 1
  })))));
};
export default SvgLpAsset2;